import { environment } from '../../../environments/environment';

export function isApiAudit(url: string) {
  const auditUrl = `${environment.apiBase}/mortgage/frontaudit/${environment.api_version.audit}/audit/save/mortgage`;
  return url === auditUrl;
}
